import React, { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { TextField } from '@mui/material';
import PostData from '../../../services/PostData.js'
import useFetch from '../../../services/useFetch.js'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

export default function ShopifyDialog() {
    const [reload, setReload] = useState(true)
    const [submitLoad, setSubmitLoad] = useState(false)
    const [successUpload, setSuccessUpload] = useState(false)
    // const [openHelp, setOpenHelp] = useState(false)
    const { data, load } = useFetch("", reload)
    const [inputVals, setInputVals] = useState([
        {
            visualName: "API Key", val: null, fieldName: "apiKey", required: true
        },
        { visualName: "API secret", val: null, fieldName: "apiSecret", required: true },
        {
            visualName: "Access Token", val: null, fieldName: "accessToken", required: true
        },
        {
            visualName: "Shopify Store URL", val: null, fieldName: "shopUrl", placeholder: "store.myshopify.com", required: true
        }
    ])

    const [errors, setErrors] = useState({});
    const handleChange = (e, field) => {
        const { value } = e.target
        setInputVals(prevVals => {
            const newVals = prevVals.map(val =>
                val.fieldName === field ? { ...val, val: value } : val
            );
            return newVals;
        });
        if (value) {
            setErrors(prevErrors => ({ ...prevErrors, [field]: '' }));
        }
    }

    const handleSubmit = async () => {
        setSubmitLoad(true)
        const newErrors = {};
        let hasError = false;

        inputVals.forEach(v => {
            if (v.required && !v.val) {
                newErrors[v.fieldName] = `${v.visualName} cannot be blank`;
                hasError = true;
            }
        });

        if (hasError) {
            setErrors(newErrors);
            setSubmitLoad(false)
            return; // Prevent submission if there are errors
        }
        const { success, error } = await PostData(inputVals, "api/manual-shopify-credentials", null)
        if (error) {
            setSubmitLoad(false)
            // setOpenTestSnack({ color: "error", message: "An error has occurred.", open: true })
            return
        }
        setSuccessUpload((true))
        // setTimeout(() => {
        //     closeDialog("success")
        // }, 1000)
    }

    return (
        <div className='row m-0' style={{ gap: '5px' }}>
            {inputVals.map((v, ind) =>
                <>
                    <div>
                        <label>
                            {v?.visualName}
                        </label>
                    </div>
                    <div className='col-12'>
                        <TextField
                            size='small'
                            // variant='standard'
                            onChange={(e) => handleChange(e, v.fieldName)}
                            value={v.val}
                            placeholder={v?.placeholder ?? ""}
                            error={!!errors[v.fieldName]} // Show error state
                            helperText={errors[v.fieldName] ?? ""}
                            sx={{ width: '300px', marginLeft: '0', color: 'gray' }}
                        />
                    </div>
                </>
            )}
            <div className='row'
                style={{ position: 'sticky', bottom: 0, backgroundColor: 'white', padding: '10px 10px', borderTop: '1px solid #e0e0e0', justifyContent: 'end', width: '350px', marginTop: '10px' }}>
                {successUpload ?
                    <button className='submit'
                        style={{ width: '205px', background: '#049e04', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span>Success</span> <CheckOutlinedIcon fontSize="small" sx={{ color: 'white', marginLeft: '10px' }} />
                    </button>
                    :
                    (!submitLoad ? <button className='submit' type='submit' onClick={handleSubmit}
                        style={{ width: '205px', height: '35px' }}>
                        Submit
                    </button> :
                        <button className='submit' type='submit' onClick={handleSubmit}
                            style={{ width: '205px', height: '35px' }}>
                            <CircularProgress size={20} sx={{ color: 'white', marginTop: '5px' }} />
                        </button>)
                }
            </div>

            {/* <Dialog maxWidth={'sm'} fullWidth open={openHelp} onClose={() => setOpenHelp(false)}>

            </Dialog> */}
        </div>
    )
}